// @ts-check
import { t } from '@lingui/macro';
import { useLingui } from '@lingui/react';
import React from 'react';

/**
 * Renders the filter columns dropdown
 * @param {object} props
 * @param {string} props.showingColumns
 * @param {React.Dispatch<React.SetStateAction<string>>} props.setShowingColumns
 * @returns {JSX.Element}
 */
export default function FilterColumns({
  showingColumns,
  setShowingColumns,
  ...rest
}) {
  const { i18n } = useLingui();
  return (
    <select
      //@ts-ignore
      sx={{ height: 24 }}
      onChange={({ target: { value } }) => {
        if (!value) return setShowingColumns('showAll');
        setShowingColumns(value);
      }}
      defaultValue={showingColumns}
      {...rest}
    >
      <option value={'showAll'}>{i18n._(t`Show all columns`)}</option>
      <option value={'showMatchedOnly'}>
        {i18n._(t`Show matched columns only`)}
      </option>
      <option value={'showUnmatchedOnly'}>
        {i18n._(t`Show unmatched columns only`)}
      </option>
    </select>
  );
}

/**
 * The filter columns dropdown hook
 * @returns {Object} { showingColumns, setShowingColumns }
 */
export function useFilterColumns() {
  const [showingColumns, setShowingColumns] = React.useState('showAll');
  return { showingColumns, setShowingColumns };
}
